<template ref="formContainer">
    <div class="profile-page">
        <section class="section-profile-cover section-shaped my-0">
            <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </section>
        
        <section class="section section-skew" >
            <div class="container">             
                <div class="row justify-content-center">
            <div class="col-lg-6">
            <!-- Tabs with icons -->
                <tabs fill class="flex-column flex-md-row" ref="tabRef">
                    <card shadow slot-scope="{activeTabIndex}">
                        <tab-pane key="tab1" name="1d">
                            <template slot="title">
                                <i class="ni ni-badge mr-2"></i>Datos Fiscales
                            </template>
                            <ul class="list-unstyled">
                                <li class="pt-2"><span class="text-success font-weight-700">1.-Ingresa el rfc.</span>
                                        <base-input
                                            v-model="cliente.rfc"
                                            placeholder="RFC Receptor"
                                            :valid="rfcValido"
                                            v-on:keyup="validarfc()"
                                            required
                                            class="mb-1">
                                            </base-input>
                                        <span class="text-danger" v-if="!rfcValido && cliente.rfc!=''">Ingrese un rfc válido</span>
                                    </li>
                                    <li class="pt-2"><h6>Razón Social: <a href="javascript:;" @click="modals.razonSocial = true">
                                            <i class="ni ni-zoom-split-in text-primary"></i>
                                        </a><small class="text-secondary">  Sin régimen societario(sin SA de CV o SRL de CV,etc.)</small></h6>                                    
                                        <ValidationProvider name="razonsocial" rules="required" v-slot="{ errors }">                                            
                                            <base-input
                                                    v-model="cliente.razonSocial"
                                                    :valid="errors.length==0&&cliente.razonSocial!=''"
                                                    placeholder="Razon Social"
                                                    class="mb-1">
                                                    </base-input> 
                                            <span class="text-danger">{{ errors[0] }}</span>
                                        </ValidationProvider>   
                                    </li>
                                    <li class="pt-2">Codigo Postal
                                        <div class="d-flex align-items-center">
                                            <ValidationProvider name="cpostal" rules="cpostal|required" v-slot="{ errors }">
                                                <small class="text-secondary"> (Exactamente el CP registrado en tu Constancia de Situación Fiscal) <a href="javascript:;" @click="modals.cpostal = true">
                                            <i class="ni ni-zoom-split-in text-primary"></i>
                                        </a></small>      
                                                <base-input
                                                    v-model="cliente.cp"
                                                    :valid="errors.length==0&&cliente.cp!=''"
                                                    v-on:keyup="validarCpostal()"
                                                    class="mb-1">
                                                    </base-input>  
                                                    <span class="text-danger">{{ errors[0] }}</span>
                                            </ValidationProvider>                                         
                                        </div>                                        
                                    </li>
                                    <li class="pt-2">Regimen Fiscal: <small class="text-secondary"> Selecciona el régimen fiscal (se podrá consultar en tu constancia de Situación Fiscal)<a href="javascript:;" @click="modals.rFiscal = true">
                                            <i class="ni ni-zoom-split-in text-primary"></i>
                                        </a></small>  
                                        <select v-model="cliente.regimenFiscal" class="form-control">
                                            <option disabled value="0">Seleccione un regimen</option>  
                                            <option v-for="option in catregimen" :key="option.clave" v-bind:value="option.clave">
                                                {{option.clave+'-' +option.descripcion }}
                                            </option>
                                        </select>
                                    </li>
                                    <li class="pt-2">Uso Cfdi:
                                        <validation-provider rules="required" v-slot="{ errors }">
                                            <select v-model="cliente.usoCFDI" class="form-control">
                                            <option disabled value="0">Seleccione uso de cfdi</option>  
                                            <option v-for="option in catusocfdi" :key="option.codigoUsoCfdi" v-bind:value="option.codigoUsoCfdi">
                                                {{option.codigoUsoCfdi+'-' +option.descripcion }}
                                            </option>
                                        </select>
                                        <span>{{ errors[0] }}</span>
                                        </validation-provider>
                                        
                                    </li>
                                    <li class="pt-2">
                                        Correo Electrónico:
                                        <validation-provider rules="email" ref="txtemail" v-slot="{ errors }">
                                            <small class="text-secondary"> Tu factura llegará a la bandeja de correo Electrónico que ingreses.</small>  
                                            <base-input 
                                            v-model="cliente.email"
                                            placeholder="Correo electrónico"
                                            :valid="errors.length==0&&cliente.email!=''"
                                            class="mb-1">
                                            </base-input>
                                            <span class="text-danger">{{ errors[0] }}</span>
                                        </validation-provider>
                                        
                                    </li>
                                    <li class="py-2">
                                        <a href="javascript:;" class="float-right" @click="modals.optionalClient = true">Capturar datos opcionales
                                            <i class="ni ni-ui-04 text-primary"></i>
                                        </a>                                     
                                    </li>
                                    <li class="pt-4 ml-5">
                                        <base-button tag="a" href="#" type="primary" @click="confirmarDatos()" class="btn-md mt-2 ml-5">
                                        <i class="ni ni-like-2"></i> Confirmar datos
                                        </base-button>
                                    </li>
                            </ul>
                        </tab-pane>
                        <tab-pane key="tab2" name="2d" v-if="paso2" :class="{active: paso2}" ref="tabTicket">
                            <template slot="title">
                                <i class="ni ni-ruler-pencil mr-2"></i>Capturar ticket
                            </template>
                            <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
                                <div>
                                    <ul class="list-unstyled">
                                    <li>
                                        <span class="font-weight-700">Razon Social:</span> {{cliente.razonSocial }}
                                    </li>
                                    <li>
                                        <span class="font-weight-700">RFC:</span> {{cliente.rfc }}
                                    </li>
                                    <li>
                                        <span class="font-weight-700">Domicilio Fiscal:</span> {{cliente.cp }}
                                    </li>
                                    <li>
                                        <span class="font-weight-700">Regimen Fiscal:</span> {{cliente.regimenFiscal }}
                                    </li>
                                    <li>
                                        <span class="font-weight-700">Uso del Cfdi:</span> {{cliente.usoCFDI }}
                                    </li>
                                    </ul>
                                </div>
                            </div>
                            <h6>Ingresa el folio de codigo de barra de tu ticket y click en validar.<a href="javascript:;" @click="modals.modalTicket = true">
                                <i class="ni ni-zoom-split-in text-primary"></i>
                                </a></h6>
                            <div class="d-flex justify-content-center mb-3 mt-3">
                                <validation-provider rules="folio" v-slot="{ errors }">
                                            <base-input 
                                            alternative
                                            v-model="folio"
                                            required
                                            placeholder="Folio ticket"
                                            :valid="folio.length==16"
                                            v-on:keyup="validarFolio()"
                                            class="mb-1">
                                            </base-input>
                                            <span class="text-danger">{{ errors[0] }}</span>
                                </validation-provider>
                                <base-button type="danger" @click="buscar()" class="btn-md btn-success float-right mb-1 ml-2">Validar</base-button>
                            </div>
                            <table class="table table-responsive pt-3" v-if="tickets.length">
                            <thead>
                                <tr>
                                    <th>Folio</th>
                                    <th>Fecha Emision</th>
                                    <th></th>
                                    </tr></thead>
                                        <tr v-for="(item, index) in tickets" :key="index">
                                            <td>
                                                {{item.folio.substring(0,16)}}
                                            </td>
                                            <td>
                                                {{item.fecha_emision}}
                                            </td>
                                            <td class="td-actions text-right">             
                                            <button type="button" rel="tooltip" @click="borrarItem(item)" class="btn btn-danger btn-icon btn-sm " data-original-title="" title="">
                                                <i class="ni ni-fat-remove pt-1"></i>
                                                </button>
                                            </td>
                                        </tr>
                                </table>
                                <base-button tag="a" href="#" type="primary" v-if="tickets.length" @click="timbrarFactura()" class="btn-md mt-2 ml-5">
                                        <i class="ni ni-like-2"></i> Timbrar CFDI
                                </base-button>

                                <div class="pt-5" v-if="facturas.length">
                                    <span class="text-success font-weight-700">Facturas generadas</span>
                                <table class="table">
                                <thead>
                                    <tr>
                                        <th>Folio</th>
                                                <th class="pl-5">
                                                    UUID
                                                </th>
                                                <th>Descargar
                                                </th>
                                            </tr>
                                        </thead>
                                        <tr v-for="(item, index) in facturas" :key="index">
                                        <td><small>{{item.folio }}</small></td>
                                        <td><small>{{item.uuid }}</small></td>
                                        <td class="td-actions text-right">
                                            <div class="d-flex align-items-center">
                                                <button type="button" rel="tooltip" @click="downloadpfd(item.uuid)" class="btn btn-danger btn-icon btn-sm ">
                                                PDF<i class="fa fa-file-pdf-o" aria-hidden="true"></i>
                                                </button>
                                                <button type="button" rel="tooltip" @click="downloadxml(item.uuid)" class="ml-2 btn btn-danger btn-icon btn-sm ">
                                                XML<i class="fa fa-file-text-o" aria-hidden="true"></i>
                                                </button>
                                            </div> 
                                            </td>
                                        </tr>
                            </table>
                                </div>
                        </tab-pane>
                    </card>
                </tabs>
            </div>
            
                <modal :show.sync="modals.razonSocial">
                    <img src="img/modals/razon_social_.png">
                </modal>
                <modal :show.sync="modals.cpostal">
                    <img src="img/modals/cpostal_.png">
                </modal>
                <modal :show.sync="modals.modalTicket">
                    <img src="img/modals/ticket_.png">
                </modal>
                <modal :show.sync="modals.rFiscal">
                    <img src="img/modals/regimen_.png">
                </modal>
                <modal :show.sync="modals.optionalClient"
                    modal-classes="modal-dialog-centered">
                <h6 slot="header" class="modal-title" id="modal-title-notification">Capture los datos opcionales</h6>

                <div class="py-1 text-center">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="calle">Calle</label>
                                <input class="form-control" v-model="cliente.calle" id="calle" type="text">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="numExterior">Numero Exterior:</label>
                                <input class="form-control" v-model="cliente.numExterior" id="numExterior" type="text">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="numInterior">Numero Interior:</label>
                                <input class="form-control" v-model="cliente.numInterior" id="numInterior" type="text">
                            </div>
                        </div>
                        <div class="col-md-8">
                            <div class="form-group">
                                <label for="colonia">Colonia:</label>
                                <input class="form-control" v-model="cliente.colonia" id="colonia" type="text">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label for="municipio">Municipio o Delegacion</label>
                                <input class="form-control" v-model="cliente.municipio" id="municipio" type="text">
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <label for="estado">Estado</label>
                            <input class="form-control" v-model="cliente.estado" id="estado" type="text">
                    
                        </div>
                        
                    </div>
                </div>
                <template slot="footer">
                    <base-button type="link"
                                 text-color="blue"
                                 class="ml-auto"
                                 @click="modals.optionalClient = false">
                        Aceptar
                    </base-button>
                </template>
            </modal>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import Loading from 'vue-loading-overlay';
import Tabs from "@/components/Tabs/Tabs.vue";
import TabPane from "@/components/Tabs/TabPane.vue";
import { ValidationProvider, extend } from 'vee-validate';
import { required,email,regex,numeric } from 'vee-validate/dist/rules';
extend('required', {
  ...required,
  message: 'Campo requerido'
});
extend('email', {
  ...email,
  message: 'Ingrese un correo valido'
});

extend('cpostal', a => {
    if (a.length > 4
           && /^\d{5}$/.test(a)
           && 12345 != a
           && !/0{5}/.test(a)
           && !/1{5}/.test(a)
           && !/2{5}/.test(a)
           && !/3{5}/.test(a)
           && !/4{5}/.test(a)
           && !/5{5}/.test(a)
           && !/6{5}/.test(a)
           && !/7{5}/.test(a)
           && !/8{5}/.test(a)
           && !/9{5}/.test(a)) {
        return true;
    }
    return 'Ingrese un codigo postal valido';
});

extend('folio', a => {
    if (a.length > 15
           && /^\d{16}$/.test(a)
           && !/0{5}/.test(a)
           && !/1{5}/.test(a)
           && !/2{5}/.test(a)
           && !/3{5}/.test(a)
           && !/4{5}/.test(a)
           && !/5{5}/.test(a)
           && !/6{5}/.test(a)
           && !/7{5}/.test(a)
           && !/8{5}/.test(a)
           && !/9{5}/.test(a)) {
        return true;
    }
    return 'Ingrese un folio valido 16 digitos';
});
import Modal from "@/components/Modal.vue";
export default {
    data(){
        return {
        tt_timeout:null,
        facturas:[],
        paso2:false,
        catregimen:[],
        catusocfdi:[],
        rfcValido:false,
        folio: "",
        formSubmitted: false,
        ticket:null,
        rfc:"",
        total:0,
        tickets:[],
        cliente:{},
        homeCont:this.$refs.formContainer,
        modals: {
            rFiscal:false,
        cpostal:false,
        razonSocial: false,
        optionalClient: false,
        modal3: false,
        modalTicket:false
        }
        };
    },
    components:{
        Loading,
        Tabs,
        TabPane,
        Modal,
        ValidationProvider
    },
    methods:{
        descargarFactura(item){
            let arr=item.fechaEmision.split('/');
            window.open("https://facturacion.cesavesin.org.mx/public/Factura.php?id=" +item.uuid+'&year='+arr[2]+'&rfc='+item.rfcReceptor+'&mes='+arr[1]+'&uid='+item.id, '_blank');
        },
        timbrarFactura(){
            let loader = this.$loading.show(
                    {
                        container: this.homeCont,
                        loader: 'spinner'
                    }
                    );
            this.axios.post('https://fe.cesavesin.mx/sia/generarcfdi_web',{tickets:this.tickets,cliente:this.cliente})
            .then((response) =>response.data)
            .then(result=>{
                this.cliente=result.cliente;
                this.facturas.push({
                    uuid:result.uuid,
                    rfc:this.cliente.rfc,
                    folio:result.folio,
                    fechaEmision:this.formatDate(result.fechaEmision),
                    id:result.id
                })
                loader.hide();
                this.tickets=[];
                this.$swal('Timbrado correctamente','','success');
            }).catch(err=>{        
                loader.hide();        
                if(err.response && err.response.data){
                    let data=err.response.data;
                    if(data.cliente){
                        this.cliente=data.cliente;
                    }
                    this.$swal('Error en el trimbrado',data.message.replace('Error en el timbrado',''),'error');
                }else{
                    this.$swal('Ocurrió un error al generar la factura, intente de nuevo','','error');
                    window.location.reload();
                }
            })
        },      
        loadMessage(){
        const hoy = new Date();
        const limite = new Date(hoy.getFullYear(), 1, 15); // Febrero = mes 1

        if (hoy <= limite) {
            this.$swal(
                'Aviso importante',
                'Si desea facturar dos o más tickets, asegúrese de que tengan el mismo importe. De lo contrario, factúrelos por separado.',
                'success'
            );
        }
    },  
        formatDate(dateString) {
            const date = new Date(dateString);
                // Then specify how you want your dates to be formatted
            return new Intl.DateTimeFormat().format(date);
        },
        calcular(){
            let total=0;
            for(let item of this.tickets){
                total=parseFloat(total)+parseFloat(item.importe)
            }
            this.total=parseFloat(total).toFixed(2);
        },
        getUsoCfdi:function(rfc){
            
            this.axios.post('https://apisia.cesavesin.mx/satUsoCfdi/usoCfdi',{tipoPerson:rfc.length==13?'F':'M'})
            .then((response) =>response.data)
            .then(result=>{
                this.catusocfdi=result.data;
            })
        },
        getCatRegimen:function(){
            this.axios.get('https://app.misfacturas.mx/sat/cat_regimen')
            .then((response) =>response.data)
            .then(result=>{
                this.catregimen=result.data;
            })
        },
        buscar:function(){
            //http://api3.cesavesin.mx/repositorioCfdi/obtenercomprobante
            
            if(this.folio.length!=16){
                this.$swal('Ingrese el folio 16 digitos');
                return;
            }
            if(this.tickets.length==19){
                this.$swal('Alcanzó el limite de facturación en pago en efectivo, $1900.00');
                return;
            }
            if(this.tickets.length){
                //buscar duplicado
                for(let item of this.tickets){
                    if(item.folio.substring(0,16)==this.folio){
                        this.$swal('Folio ya registrado.');
                        this.folio='';
                        return;
                    }
                }
            }
            let loader = this.$loading.show(
                    {
                        container: this.homeCont,
                        loader: 'spinner',
                    }
                    );
            this.axios.post('https://apisia.cesavesin.mx/repositorioCfdi/obtenerticket',{folio:this.folio,rfc:this.rfc})
            .then((response) =>response.data)
            .then(resp=>{
                loader.hide()
                this.folio='';
                this.ticket=resp.data;
                this.tickets.push(resp.data);
                this.calcular()
            }).catch(err=>{
                loader.hide()
                this.$swal(err.response.data.message,'','error');
            }) 
        },
        validarCpostal:function(){
            let cp=this.cliente.cp;
            this.cliente.cp=cp.replace(/[^0-9.]/g, '');
        },
        validarfc:function(){
            this.rfcValido=false;
            this.cliente.rfc=this.cliente.rfc.trim().toUpperCase()
            if(this.cliente.rfc.length>13){
                this.cliente.rfc=this.cliente.rfc.substring(0,13)
            }
            if(this.validateRfc(this.cliente.rfc)){
                this.rfcValido=true;
                if(this.cliente.rfc=='XAXX010101000'){
                    this.$swal("No se puede facturar con rfc generico")
                    this.cliente.rfc="";
                    return;
                }

                if(this.t_timeout){
                    clearTimeout(this.t_timeout);
                }
                this.t_timeout=setTimeout(() =>{
                    let loader = this.$loading.show(
                    {
                        container: this.homeCont,
                        loader: 'spinner'
                    }
                    );
                    //cliente/getbyrfc
                    this.axios.post('https://apisia.cesavesin.mx/repositorioCfdi/getbyrfc',{rfc:this.cliente.rfc})
                    .then((response) =>response.data)
                    .then(resp=>{
                        loader.hide()
                        this.cliente=resp.data;
                        this.getUsoCfdi(this.cliente.rfc)
                        if(this.cliente.actualizado4_0=='N'){
                        this.$swal('Favor de actualizar los datos de facturacion','','warning');
                        }
                        this.facturas=[]
                        this.tickets=[]
                        this.paso2=false;
                        this.t_timeout = null;
                }).catch(err=>{
                if(err.response.status==404){
                    this.nuevoCliente();
                    this.cliente.rfc=err.response.data.data.rfc;
                    this.getUsoCfdi(this.cliente.rfc)
                    this.$swal(err.response.data.message,'Capture sus datos fiscales.','info');
                }else{
                    this.$swal(err.response.data.message,'','error');
                }
                loader.hide()
                this.facturas=[]
                this.tickets=[]
                this.paso2=false;
                this.t_timeout = null;
            }) 
                },500)
            }else{
                this.facturas=[]
                this.tickets=[]
                this.paso2=false;
            }
            //return data.isValid;
        },
        confirmarDatos:async function(){
            //hacer validaciones de cp
            if(this.cliente.rfc=="" || this.cliente.razonSocial==''){
                this.$swal("Favor de ingresar los datos del cliente.",'','error');
                return;
            }
            let cpValid=await this.validaCp(this.cliente.cp);
            if(!cpValid)return;
            if(this.cliente.regimenFiscal=="0" || this.cliente.regimenFiscal==''){
                this.$swal("Seleccione un regimen fiscal",'','error');
                return;
            }
            if(this.cliente.usoCFDI=="0" || this.cliente.usoCFDI==''){
                this.$swal("Seleccione el uso de cfdi",'','error');
                return;
            }
            if(this.cliente.rfc==''){
                this.$swal("Ingresa el RFC",'','error');
                return;
            }
            if(this.cliente.razonSocial==''){
                this.$swal("Ingresa la razon social.",'','error');
                return;
            }
            this.tickets=[];
            this.facturas=[];
            this.paso2=true;
            setTimeout(()=>{this.$refs.tabRef.activateTab(this.$refs.tabTicket)}, 50)
            return;
        },
        validaCp:function(cp){

            return this.axios.post('https://apisia.cesavesin.mx/repositorioCfdi/validacp',{codigoPostal:cp})
            .then((response) =>response.data)
            .then(result=>{
                return result;
            }).catch(eerr=>{
                this.$swal("El codigo postal no se encuentra en el listado del SAT",'','error');
                this.cliente.cp='';
                return false;
            })
        },
        validarFolio:function(){
            this.folio=this.folio.replace (/[^ 0-9]/g,'');
        },
        borrarItem:function(item){
        let index = this.tickets.indexOf(item);
        if(index>-1){
            this.tickets.splice(index, 1);
            this.calcular()
        }
    },
    validateRfc:function(rfc) {
        let _rfc_pattern_pm = "^(([A-ZÑ&]{3})([0-9]{2})([0][13578]|[1][02])(([0][1-9]|[12][\\d])|[3][01])([A-Z0-9]{3}))|" +
              "(([A-ZÑ&]{3})([0-9]{2})([0][13456789]|[1][012])(([0][1-9]|[12][\\d])|[3][0])([A-Z0-9]{3}))|" +
              "(([A-ZÑ&]{3})([02468][048]|[13579][26])[0][2]([0][1-9]|[12][\\d])([A-Z0-9]{3}))|" +
              "(([A-ZÑ&]{3})([0-9]{2})[0][2]([0][1-9]|[1][0-9]|[2][0-8])([A-Z0-9]{3}))$";
 let _rfc_pattern_pf = "^(([A-ZÑ&]{4})([0-9]{2})([0][13578]|[1][02])(([0][1-9]|[12][\\d])|[3][01])([A-Z0-9]{3}))|" +
                   "(([A-ZÑ&]{4})([0-9]{2})([0][13456789]|[1][012])(([0][1-9]|[12][\\d])|[3][0])([A-Z0-9]{3}))|" +
                   "(([A-ZÑ&]{4})([02468][048]|[13579][26])[0][2]([0][1-9]|[12][\\d])([A-Z0-9]{3}))|" +
                   "(([A-ZÑ&]{4})([0-9]{2})[0][2]([0][1-9]|[1][0-9]|[2][0-8])([A-Z0-9]{3}))$";
   return rfc.match(_rfc_pattern_pm) || rfc.match(_rfc_pattern_pf);
},
        nuevoCliente:function(){
            this.cliente={
            id:0,
            razonSocial:'',
            rfc:'',
            situacionFiscal:'',
            estado:'',
            municipio:'',
            calle:'',
            numExterior:'',
            numInterior:'',
            colonia:'',
            cp:'',
            email:'',
            regimenFiscal:'0',
            usoCFDI:'0',
            checked: 0, 
            actualizado4_0:'S', 
            complementoRazonSocial: null
        }
        },
        downloadpfd:function(uuid){
            window.open(`https://apisia.cesavesin.mx/clientecfdi/downloadpdf?uuid=${uuid}`);
            //window.location.reload()
        },
        downloadxml:function(uuid){
            window.open(`https://apisia.cesavesin.mx/clientecfdi/downloadxml?uuid=${uuid}`);
            //window.location.reload()
        },
    },
    mounted:function(){
        this.nuevoCliente()
        this.getCatRegimen()
        this.loadMessage()
        //this.getUsoCfdi()
    }
};
</script>
<style>
.loading-parent {
    position: relative;
}
.table-responsive {
    max-height:300px;
}

</style>
